






















































































































import Vue from 'vue'
import { DataTreeNode } from '@/utils/array'
import {
  WorkStationGroupServiceProxy
} from "@/service-proxies/app-v2/workStation.service-proxies";
import { ShiftServiceProxy } from '@/service-proxies/app-v2/time.service-proxies';
import { exportAnalysis } from '@/api/api';
import dayjs from 'dayjs';
import moment from 'moment';
const ssp = new ShiftServiceProxy()
const wsgsp = new WorkStationGroupServiceProxy()

export default Vue.extend({
  name: "export-modal",
  data(){
    return{
      filter: {
        endDate: '',
        startDate: '',
        statisticalMethod: 'SHIFT',
        shiftList: [],
        workStationList: []
      },
      checkShift: [],
      rangeData: [null,null],
      checkedKeys: [],
      expendKeys: [],
      treeData: [],
      workStatoinItems: [],
      shiftIndexs: [],
      cilentHeight: '260px',
      loading: false
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    'visible':{
      handler(){
        if(this.visible){
          this.rangeData[0] = dayjs().subtract(6, 'day').valueOf()
          this.rangeData[1] = dayjs().valueOf()
          this.treeData = []
          this.getShift()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    moment,
    getShift(){
      this.shiftIndexs = []
      this.checkShift = []
      ssp.getShiftIndexName().then(res =>{
        if(res.keyNameDTOList){
          this.shiftIndexs = res.keyNameDTOList
          res.keyNameDTOList.forEach(res =>{
            this.checkShift.push(res.key)
          })
        }
        this.getTreeList()
      })
    },
    expandKey(value){
      this.expendKeys = value
    },
    getTreeList(){
      this.workStatoinItems = []
      this.expendKeys = []
      this.checkedKeys = []
      wsgsp.workStationGroupList().then(res =>{
        if(res){
          const keys = []
          let i = 0
          const data = res.reduce((total, value) =>{
            const key = value.id + '-' + value.parentId
            total.push({
              ...value,
              key: key
              })
              if(value.isWorkStation){
                if(i < 5){
                  keys.push(key)
                  i = 1 + i
                }
              } else {
                this.expendKeys.push(key)
              }
            return total
          }, [])
          this.treeData = DataTreeNode.arrayToTree(data);
          this.workStatoinItems = data
          this.checkedKeys = keys
        }
      })
    },
    addKeyId(item){
      const key = item.id + '-' + item.parentId
      return key
    },
    setWorkStationList(){
      const List = []
      const recheckKeys = []
      this.workStatoinItems.map(res =>{
        if(this.checkedKeys.includes(this.addKeyId(res)) && !recheckKeys.includes(res.id) && !res.isGroup){
          recheckKeys.push(res.id)
          const data = {
            key: res.id,
            name: res.title
          }
          List.push(data)
        }
      })
      return List
    },

    hanldeCancel(){
      this.$emit('cancel')
    },

    hanldeOutPut(){
      this.filter.workStationList = []
      this.filter.shiftList = []
      if(this.filter.statisticalMethod === 'MONTH'){
        const startDate = dayjs(this.rangeData[0]).startOf('month')
        const endDate = dayjs(this.rangeData[1]).endOf('month')
        this.filter.startDate = dayjs(startDate).format('YYYY-MM-DD')
        this.filter.endDate = dayjs(endDate).format('YYYY-MM-DD')
      } else if(this.filter.statisticalMethod === 'WEEK'){
        const startDate = dayjs(this.rangeData[0]).startOf('week').add(1,'day').valueOf()
        const endDate = dayjs(this.rangeData[1]).endOf('week').add(1,'day').valueOf()
        this.filter.startDate = dayjs(startDate).format('YYYY-MM-DD')
        this.filter.endDate = dayjs(endDate).format('YYYY-MM-DD')
      } else {
        this.filter.startDate = dayjs(this.rangeData[0]).format('YYYY-MM-DD')
        this.filter.endDate = dayjs(this.rangeData[1]).format('YYYY-MM-DD')
      }

      this.filter.workStationList = this.setWorkStationList()
      this.shiftIndexs.map(res =>{
        if(this.checkShift.includes(res.key)){
          const data = {
            key: res.key,
            name: res.name
          }
          this.filter.shiftList.push(data)
        }
      })
      if(dayjs(this.rangeData[0]).valueOf() > dayjs(this.rangeData[1]).valueOf()){
        this.$message.warning('开始时间不能大于结束时间')
        return
      }
      if(this.filter.workStationList.length < 1){
        this.$message.warning(this.$t('page_time_analysis_selectworkstation'))
        return
      }
      if(this.filter.statisticalMethod === 'SHIFT' && this.filter.shiftList < 1){
        this.$message.warning('请选择班次')
        return
      }
      this.export()
    },

    export(){
      this.loading = true
      exportAnalysis(this.filter).then(res =>{
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        a.download = `${this.$t('page_time_analysis')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        // var blob = new Blob([res])
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
        this.loading = false
        this.$emit('cancel')
      }).catch(() =>{
        this.loading = false
      })
    },

    selectStatisticalMethod(value){
      this.filter.statisticalMethod = value
    },

    selectShiftIndexs(value){
      this.checkShift = value
    },

    rangeChange(value){
      this.rangeData = value
    },

    monthRangeChange(value){
      this.$set(this.rangeData, 0 ,dayjs(value).format('YYYY-MM'))
      this.$set(this.rangeData, 1 ,dayjs(value).format('YYYY-MM'))
    },

    weekStrartChange(value){
      this.$set(this.rangeData, 0 ,dayjs(value).format('YYYY-MM-DD'))
    },

    weekEndChange(value){
      this.$set(this.rangeData, 1 ,dayjs(value).format('YYYY-MM-DD'))
    },

    onSelect(value){
      console.log(value)
      this.checkedKeys = value
    }
  }
})
